module.exports = __webpack_public_path__ + "static/media/Shubham_Gupta.b0fb12e8.jpg";